import { GenericAbortSignal } from "axios";
import { AutoCompleteDataModel, AutoCompleteSuggestions, MprcAutoComplete } from "components/MprcAutoComplete";
import { IAutoCompleteProps } from "components/MprcAutoComplete/AutoComplete";
import { isCanceledError, useCoreApi } from "providers/CoreApiProvider";

////////////////////////////////////////////////////////////////////////////

interface Props extends Omit<IAutoCompleteProps, 'onGetSuggestions'> {
    trainingId?: string;
}

////////////////////////////////////////////////////////////////////////////

/**
 * Auto complete de instrutores do treinamento.
 * @param props
 */
export const SupervisorInstructorsAutoComplete: React.FC<Props> = ({ trainingId, onError, ...props }) => {

    const api = useCoreApi();

    ///
    const getSuggestions = (searchText: string, pageNumber: number, pageSize: number, trySelectedHistory: boolean, signal: GenericAbortSignal | undefined): Promise<AutoCompleteSuggestions<AutoCompleteDataModel>> => {
        searchText = searchText.toLowerCase();

        return new Promise<AutoCompleteSuggestions<AutoCompleteDataModel>>((resolve) => {
            api.v1.lmsSuggestions.supervisorInstructors({
                searchText,
                pageNumber,
                pageSize,
            }, { signal })
                .then(result => resolve({
                    items: result.data.items,
                    totalRows: result.data.totalRows
                }))
                .catch(e => {
                    if (!isCanceledError(e)) {
                        resolve({ items: [], totalRows: 0 });
                        if (onError) onError(e);
                    }
                });
        });
    };

    ////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////


    return (
        <MprcAutoComplete
            {...props}
            onError={onError}
            onGetSuggestions={getSuggestions}
        />
    );
};
